__turbopack_context__.v({
  "container": "LogoConstruction-module__GBQ39W__container",
  "svg": "LogoConstruction-module__GBQ39W__svg",
});
